<template>
	<div class="xs-12">
		<!-- Options -->
		<div class="r2 b1 bc7 p2">
			<div v-for="(option, i) in options" :key="i" class="flex xs-middle">
				<j-base-input-text
					class="xs mb1"
					size="small"
					v-model="option.localizedContent"
					@blur="updateOptionLocalization(option)"
				/>
				<div class="flex xs-right cu2" @click="removeOptionFromItem(option)">
					<crm-icon name="delete" color="cError" />
				</div>
			</div>
			<j-button
				class="mt1"
				type="tertiary"
				size="xsmall"
				@click="addOptionToLessonItem"
				>+{{ $t("add_option") }}</j-button
			>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JBaseInputText from "@/components/JBaseInputText"
import CrmIcon from "@/components/CrmIcon"

import { checkSuccess } from "../utils/helpers.js"
import api from "@/api/gql.js"
import queries from "../utils/queries.js"

export default {
	props: {
		// localized content
		value: String,

		// Full item
		item: Object,

		// Ids of course and lesson, needed for the calls
		courseId: String,
		lessonId: String,

		selectedLocale: String
	},

	components: {
		JButton,
		JBaseInputText,
		CrmIcon
	},

	computed: {
		options() {
			return this.item?.options || []
		}
	},

	methods: {
		async addOptionToLessonItem() {
			let variables = {
				courseId: this.courseId,
				lessonId: this.lessonId,
				itemId: this.item.id,
				input: {
					isCorrect: false
				}
			}

			let res = await api({ query: queries.addOptionToLessonItem, variables })

			if (
				!checkSuccess(
					res,
					"addOptionToLessonItem",
					this.$t("errors.general"),
					this.$store
				)
			)
				return
			this.$emit("option:added")
		},

		async updateOptionLocalization(option) {
			if (!option?.localizedContent) return
			const variables = {
				l10n: {
					key: `lessonItemsOptions-${option.id}-content`,
					locale: this.selectedLocale,
					value: option.localizedContent || ""
				}
			}

			const res = await api({ query: queries.upsertL10n, variables })

			if (
				!checkSuccess(res, "upsertL10n", this.$t("errors.general"), this.$store)
			)
				return
			this.$emit("option:updated")
		},

		async removeOptionFromItem(option) {
			if (this.isLoading) return
			// Remove item from lesson
			let variables = {
				courseId: this.courseId,
				lessonId: this.lessonId,
				itemId: this.item.id,
				optionId: option.id
			}

			let res = await api({
				query: queries.removeOptionFromLessonItem,
				variables
			})

			if (
				!checkSuccess(
					res,
					"removeOptionFromLessonItem",
					this.$t("errors.general"),
					this.$store
				)
			)
				return
			// Delete l10n localizedContent
			variables = {
				key: `lessonItemsOptions-${option.id}-content`
			}
			res = await api({ query: queries.deleteAllL10n, variables })
			this.$emit("option:removed")
		}
	}
}
</script>
